<div *ngFor="let item of data;let i = index;" class="accordion-container" [class.accordion-on]="item.isActive">
    <button class="accordion" (click)="toggleAccordian($event, i)"> {{item.title}} </button>
    <div class="panel" hide="!item.isActive">
        <div [innerHTML]="item.content"></div>
    </div>
</div>